
<template>
    <div class="wrap">
        <div class="boeder">aaa</div>
        <div class="boeder">bbb</div>
    </div>
</template>


<script>
export default {};
</script>>

<style scoped>
.wrap {
    padding: 20px;
}
.boeder {
    resize: vertical;
    border: 1px solid black;
    margin: 10px;
    overflow: auto;
}
</style>